import { render, staticRenderFns } from "./BoardCreated.vue?vue&type=template&id=1ff87025&scoped=true&"
import script from "./BoardCreated.vue?vue&type=script&lang=js&"
export * from "./BoardCreated.vue?vue&type=script&lang=js&"
import style1 from "./BoardCreated.vue?vue&type=style&index=1&id=1ff87025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff87025",
  null
  
)

export default component.exports